export default "__VITE_ASSET__Cam3Wl8t__"